<template>
  <div></div>
</template>

<script>
export default {
  name: 'Logout',

  methods: {
    /**
     * Logout the authenticated user.
     */
    logout() {
      this.$store.commit('applicationWasLoading');

      this.$store.dispatch('auth/logout');

      this.$router.push({ name: 'Auth-Login' });

      this.$store.commit('applicationWasNotLoading');
    },
  },

  mounted() {
    this.logout();
  },
};
</script>
